<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    :close-on-click-modal="false"
    :fullscreen="true"
    :append-to-body="true"
    @opened="getData(false)"
    :before-close="beforeClose"
    :destroy-on-close="false"
  >
    <div v-if="data">
      <Plan
        ref="plan"
        :data="data"
        :needShow2MatchBtn="needShow2MatchBtn"
        :refresh="() => getData(true)"
        :closeFun="closeFun"
        :testMode="testMode"
        :orderId="orderId"
        :order="order"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getRoutePlan, getTestRoutePlan, prepareForTestRoutePlan } from "@/api";
import Plan from "./Plan.vue";
import { SessionStorage } from "@/util";
import { ROUTE_PLAN_MAP } from "@/core/const/global-const";
export default {
  components: {
    Plan
  },

  data() {
    return {
      visible: false,
      data: null,
      needShow2MatchBtn: false,
      testMode: false,
      order: null,
      routeId: null,
      orderId: null
    };
  },

  methods: {
    show(route, needShow, order) {
      this.needShow2MatchBtn = needShow;
      this.route = route;
      this.testMode = false;
      this.order = order;
      this.visible = true;
      this.callback = null;
    },

    showTest(routeId, orderId, callback) {
      this.testMode = true;
      this.routeId = routeId;
      this.orderId = orderId;
      this.order = null;
      this.callback = callback;

      // 为模拟派单做准备
      prepareForTestRoutePlan(routeId, orderId).then(() => {
        this.visible = true;
      });
    },

    getData(forceRefresh = false) {
      // 刷新数据的时候，不隐藏原数据
      if (!forceRefresh) {
        this.data = null;
      }
      if (!this.testMode) {
        const { id } = this.route;

        getRoutePlan(id).then((res) => {
          this.data = res.data;
          if (forceRefresh) {
            this.$nextTick(() => {
              this.$refs.plan.initData();
            });
          }
        });
      } else {
        const { routeId, orderId } = this;
        const cacheKey = this.getCacheKey();
        const map = SessionStorage.get(ROUTE_PLAN_MAP) || {};
        if (map[cacheKey] && !forceRefresh) {
          this.data = map[cacheKey];
        } else {
          getTestRoutePlan(routeId, orderId).then((res) => {
            this.data = res.data;
            map[cacheKey] = this.data;
            SessionStorage.set(ROUTE_PLAN_MAP, map);
            if (forceRefresh) {
              this.$nextTick(() => {
                this.$refs.plan.initData();
              });
            }
          });
        }
      }
    },

    closeFun(finishedPlan = false) {
      if (this.callback) {
        this.callback(finishedPlan);
      }
      this.visible = false;
    },

    beforeClose(done) {
      done && done();
      this.data = null;
    },

    getCacheKey() {
      return `${this.routeId}_${this.orderId}`;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  padding: 0;
}
</style>
